import React, { useState, useEffect, useMemo } from "react";
import "../../Assests/Scss/AddUpdateQuestions.scss";
import Loading from "../../../../Student/Reusablecomponents/Loading";
import {
  BackNavigation,
} from "../../../../Student/Reusablecomponents/RegularFunctions";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../../../../Student/Reusablecomponents/DropDownValues";
import {
  MainSource,
  SubMainSource,
  QVStatus,
  DDContent,
  DDTopic,
  DDSubTopic,
  DDLearningOC,
  DDSubLearningOC,
  NCERTLO,
  QuestionLevel,
  FormQuestions,
  BloomTaxonomy,
  DDContext,
} from "../../../../ReusableComponents/QBDropdowns";
import { GoTriangleDown } from "react-icons/go";
import { Row, Col } from "react-bootstrap";
import TinyMCEDitor from "../../../../ReusableComponents/tinymceEditor";
import notify from "../../../../ReusableComponents/ToastifyAlerts";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import QS from "../../Assests/images/QuestionSource.svg";
import Q from "../../Assests/images/Question.svg";
import LO from "../../Assests/images/LO.svg";
import AP from "../../Assests/images/AParameters.svg";
import Forms from "../../Assests/images/Forms.svg";
import {
  AnswerType,
  AnswerValuetype,
  UnitsDD,
} from "../../../../ReusableComponents/QBDropdowns";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { InputType } from "../../../../ReusableComponents/CommonFunctions";
import axiosInstance from "../../../../ReusableComponents/Axios";
import QBCList from "../../../../ReusableComponents/QBCheckList";
import {
  StageDD, CircularGoalDD, CompetenciesDD,
} from "../../../../ReusableComponents/QBAdmin/CommonDropdowns";
const CloneAddQuestion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const GetQuestion = useSelector(
    (state) => state.QuestionDeatils.QuestionDetails
  );
  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );

  const [Load, SetLoad] = useState(false);
  const [MDQ, SetMDQ] = useState(
    GetQuestion
      ? GetQuestion?.questionType
      : location.state?.Tab === "INQ"
      ? "D"
      : "M"
  );

  const [Accordion, SetAccordion] = useState("All");

  const [EditorValues, SetEditorValues] = useState({
    Question: "",
    Answer: "",
    OptionA: "",
    OptionB: "",
    OptionC: "",
    OptionD: "",
    Explanation: "",
    Misconception: "",
  });
  const [OComments, SetOComments] = useState({
    Source: GetQuestion?.otherQSource || "",
    Verification: GetQuestion?.verificationComment || "",
    Form: GetQuestion?.otherFormComments || "",
  });

  const [NTBased, SetNTBased] = useState(GetQuestion?.sSourceLovId || "");
  const [SNTBased, SetSNTBased] = useState(GetQuestion?.sSourceValueId || "");
  const [VStatus, SetVStatus] = useState(GetQuestion?.qStatus || "");

  const [Content, SetContent] = useState(GetQuestion?.content || "");
  const [Topic, SeTopic] = useState(GetQuestion?.topic || "");
  const [SubTopic, SetSubTopic] = useState(GetQuestion?.subTopic || "");
  const [LOC, SetLOC] = useState(GetQuestion?.lo || "");
  const [SubLOC, SetSubLOC] = useState(GetQuestion?.subLO || "");
  const [NCERTLOC, SetNCERTLOC] = useState(GetQuestion?.ncertlo || "");
  const [GetGrade, SetGetGrade] = useState();
  const [CNumber, SetCNumber] = useState();
  const [ChapterOpt, SetChapterOpt] = useState();
  const [GradeOpt, SetGradeOpt] = useState();
  const [QLevel, SetQLevel] = useState(GetQuestion?.level || "");
  const [BTaxonomy, SetBTaxonomy] = useState(GetQuestion?.bloomsTaxonomy || "");
  const [Context, SetContext] = useState(GetQuestion?.context || "");

   const [SStage, SetSStage] = useState(GetQuestion?.stage || "");
    const [SCGoal, SetSCGoal] = useState(GetQuestion?.curricularGoal || "");
    const [Competencie, SetCompetencie] = useState(GetQuestion?.competency || "");

    
        const [OpenDeatils, SetOpenDeatils] = useState(false);
      const [FSCGoal, SetFSCGoal] = useState();
      const [FCompetencie, SetFCompetencie] = useState();

  const [FormQ, SetFormQ] = useState(GetQuestion?.elementType || []);

  const [AQErrors, SetAQErrors] = useState({});

  const [NCERTDetails, SetNCERTDetails] = useState();

  // Below are the input Question Type
  const [AType, SetAType] = useState(GetQuestion?.answerType || "");
  const [AVType, SetAVType] = useState(GetQuestion?.answerValType || "");
  const [Units, SetUnits] = useState(GetQuestion?.unitId || "");

  const [MultipleInputs, setMultipleInputs] = useState([""]);
  const [RangeValues, SetRangevalues] = useState({
    From: "",
    To: "",
  });
  const handleAddInput = () => {
    if (MultipleInputs.length < 5) {
      setMultipleInputs([...MultipleInputs, ""]);
    } else {
      alert("A maximum of 5 answers only can be added.");
    }
  };

  const handleRemoveInput = (index) => {
    const newInputs = MultipleInputs.filter((_, i) => i !== index);
    setMultipleInputs(newInputs);
  };

  const handleChange = (index, e) => {
    if (AVType?.Name === "S") {
      StoreEditorValues("Answer", e.target.value);
    } else {
      const newInputs = [...MultipleInputs];
      switch (AType?.Name) {
        case "T":
          const CONVERT = e.target.value.replace(/[^a-zA-Z]/g, "");
          newInputs[index] = CONVERT;
          break;
        case "F":
          const CONVER = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
          newInputs[index] = CONVER;
          break;
        default:
          newInputs[index] = e.target.value;
          break;
      }
      setMultipleInputs(newInputs);
    }
  };
  // Above are the input Question Type

  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    SNTBased: Yup.string().required("Source is required"),
    VStatus: Yup.string().required("Question Verification status is required"),
    Question: Yup.string().required("Question is required"),
    Answer: Yup.string().when("AVType", {
      is: () => AVType?.Name === "S" || MDQ === "M",
      then: (schema) => Yup.string().required("Answer is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    MultipleInputs: Yup.array().when("AVType", {
      is: () => AVType?.Name === "M",
      then: (schema) =>
        schema
          .required("Answers are required")
          .min(1, "At least one answer is required")
          .test("", "Answers are required", (arr) => {
            return (
              Array.isArray(arr) &&
              arr.every(
                (item) => typeof item === "string" && item.trim().length > 0
              )
            );
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
    From: Yup.string().when("AVType", {
      is: () => AVType?.Name === "R",
      then: (schema) => schema.required("Range From is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    To: Yup.string().when("AVType", {
      is: (AVType) => AVType?.Name === "R",
      then: (schema) => schema.required("Range To is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    OptionA: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: (schema) => Yup.string().required("Option A is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    OptionB: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: () => Yup.string().required("Option B is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    QForm: Yup.string().required("Forms in Question is required"),
    Form: Yup.string().when("FormQ", {
      is: (FormQ) => FormQ.includes(4002),
      then: (schema) => Yup.string().required("Form input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Source: Yup.string().when("SNTBased", {
      is: (SNTBased) => SNTBased === 3574 || SNTBased === 3578,
      then: (schema) => Yup.string().required("Source input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Content: Yup.string().required("Content is required"),
    Topic: Yup.string().required("Topic is required"),
    SubTopic: Yup.string().required("Sub Topic is required"),
    LOC: Yup.string().required("Learning Outcomes is required"),
    GetGrade: Yup.string().required("Grade is required"),
    CNumber: Yup.string().required("Chapter is required"),
    QLevel: Yup.string().required("Question level is required"),
    BTaxonomy: Yup.string().required("Bloom's Taxonomy is required"),
    Context: Yup.string().required("Context is required"),
    Units: Yup.string().when("2", {
      is: () => AType?.Name === "U",
      then: (schema) => Yup.string().required("Units is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
       SStage: Yup.string().required("Stage is required"),
        SCGoal: Yup.string().required("Curricular Goal is required"),
        Competencie: Yup.string().required("Competencies is required"),
  });

  const OpenAccordain = (e) => {
    if (Accordion === e) {
      SetAccordion();
    } else {
      SetAccordion(e);
    }
  };

  const StoreEditorValues = (Name, Values) => {
    SetEditorValues({ ...EditorValues, [Name]: Values });
  };
  const HandelOComments = (Name, Values) => {
    SetOComments({ ...OComments, [Name]: Values });
  };
  const FormSOptions = (e) => {
    if (FormQ.includes(e)) {
      SetFormQ((prevItems) => prevItems.filter((item) => item !== e));
    } else {
      SetFormQ([...FormQ, e]);
    }
  };
  const QForm = FormQ?.join(",");

  useEffect(() => {
    if (LOC) {
      GETChaptergrade();
    }
  }, [LOC]);

  const GETChaptergrade = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetGradeAndChapterByLO?LovId=${LOC}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const ChapterOp = [];
        const GradeOp = [];
        res.data.map((item) => {
          if (
            !ChapterOp.some((chapter) => chapter.value === item.chapterLovId)
          ) {
            ChapterOp.push({
              display: item.chapterName,
              value: item.chapterLovId,
            });
          }
          if (!GradeOp.some((grade) => grade.value === item.gradeLovId)) {
            GradeOp.push({ display: item.gradeName, value: item.gradeLovId });
          }
        });
        SetChapterOpt(ChapterOp);
        SetGradeOpt(GradeOp);

        SetCNumber(GetQuestion?.chapterId || "");
        SetGetGrade(GetQuestion?.gradeId || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetNCERTLOCDetails = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${items?.subjectId}&LovCategoryId=8&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetNCERTDetails(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const NCERTColumns = [
    { name: "LO Code", selector: "lovName", sortable: true },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "justify" }}>{row.description} </div>
      ),
    },
  ];
  const AddQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionID: 0,
      questionType: MDQ,

      scenarioID: Scenario?.scenarioID || 0,
      subjectId: items?.subjectId,

      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: items?.userId,

      content: Content,
      topic: Topic,
      subTopic: SubTopic,
      lo: LOC,
      subLO: SubLOC || 0,
      ncertlo: NCERTLOC || 0,
      gradeId: GetGrade,
      chapterId: CNumber,

      context: Context,
      bloomsTaxonomy: BTaxonomy,
      level: QLevel,

      elementType: QForm,
      otherFormComments: OComments?.Form,

      isClone: 1,
      parentQBID: GetQuestion?.questionID,
      AnswerType: AType?.Value || 0,
      AnswerValType: AVType?.Value || 0,
      AnswerValue:
        AVType?.Name === "M"
          ? MultipleInputs?.join(",")
          : (AVType?.Name === "R" &&
              `${RangeValues?.From},${RangeValues?.To}`) ||
            "",

      UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
        stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/QuestionBank/AddMathsQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
       
       notify("Question added successfully", "success");
        SetLoad((prev) => !prev);
        BackPreviousPage();
      })
      .catch((err) => {
        console.log(err);
         notify("Question not added. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };

  const Validation = () => {
    const AllFields = {
      ...EditorValues,
      NTBased,
      SNTBased,
      VStatus,
      Content,
      Topic,
      SubTopic,
      LOC,
      SubLOC,
      NCERTLOC,
      GetGrade,
      CNumber,SStage, SCGoal, Competencie,
      QLevel,
      BTaxonomy,
      Context,
      QForm,
      ...OComments,
      FormQ,
      Units,
      MultipleInputs,
      AVType,
      ...RangeValues,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
         if (CValidation) {
        AddQuestion(AllFields);}
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };

  const BackPreviousPage = () => {
    navigate(-2);
  };
  const inputValue = (index) => {
    if (AVType?.Name === "S") {
      return EditorValues.Answer;
    } else {
      return MultipleInputs[index].trim();
    }
  };

   useMemo(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
     const [HitCLV, SetHitCLV] = useState(false);
      const [CValidation, SetCValidation] = useState(false);
      const [QCValues, SetQCValues] = useState();
      useEffect(() => {
        if (CValidation) {
          Validation();
        }
      }, [CValidation]);
      const Columns = [
    { name: "Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "lovDescription", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.lovDescription} </div>),
    },
  ];
  return (
    <>
      <BackNavigation Navigation={() => BackPreviousPage()} />
      <div className="MainHeading">Clone Add Question</div>
      {Scenario?.scenarioID && (
        <div className="Card mb-3">
          <div className="SubHeading mb-2">
            Scenario (Id - {Scenario?.scenarioID})
          </div>
          <ScenarioQuestionformat scenario={Scenario?.scenarioName} />
        </div>
      )}

      <div className="Card">
        <div className="dflex alignitems mb-2" style={{ gap: "30px" }}>
          {["M", "D"].map((item) => (
            <div className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="radio"
                value={item}
                checked={item === MDQ}
                name="Qtype"
                disabled={
                  location.state?.Tab === "INQ" || location.state?.Tab === "INQ"
                }
                onChange={(e) => {
                  if (!GetQuestion) {
                    SetEditorValues({ ...EditorValues, Answer: "" });
                  }
                  SetMDQ(e.target.value);
                }}
              />{" "}
              {item === "M" ? "MCQ" : "NON MCQ"}
            </div>
          ))}
        </div>
        <div className="dflex alignitems mb-2" style={{ gap: "30px" }}>
          <div className="SubHeading">Clone Add Question</div>
        </div>

        <div>
          <div className="AddOptions">
            <div
              className="dflex alignitems JSBetween AUTitles"
              onClick={() => OpenAccordain("QS")}
            >
              <div className="dflex alignitems">
                {" "}
                <img src={QS} alt="Question Source" />{" "}
                <div>
                  Question<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown />
            </div>
            {Accordion !== "QS" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <MainSource
                      className="NCLDropdown w-100 mb-2"
                      StoreMSource={SetNTBased}
                      SOption={NTBased}
                      onChange={(e) => SetNTBased(e)}
                      LID={SelectLanguage}
                      labelname={
                        <div className="DropdownHeader">
                          Source<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.NTBased && (
                      <span className="error-message">{AQErrors?.NTBased}</span>
                    )}
                    <SubMainSource
                      className="NCLDropdown w-100"
                      StoreSMSource={SetSNTBased}
                      SOption={SNTBased}
                      PId={NTBased}
                      LID={SelectLanguage}
                      onChange={(e) => SetSNTBased(e)}
                    />
                    {AQErrors?.SNTBased && (
                      <span className="error-message">
                        {AQErrors?.SNTBased}
                      </span>
                    )}

                    {(SNTBased === 3574 || SNTBased === 3578) && (
                      <input
                        type="text"
                        className="Search mt-2 p-1 w-100"
                        onChange={(e) =>
                          HandelOComments("Source", e.target.value)
                        }
                        placeholder="Enter Comments"
                      />
                    )}
                    {AQErrors?.Source && (
                      <span className="error-message">{AQErrors?.Source}</span>
                    )}
                    <QVStatus
                      className="NCLDropdown w-100 mb-2"
                      StoreValue={SetVStatus}
                      SOption={VStatus}
                      LID={SelectLanguage}
                      onChange={(e) => SetVStatus(e)}
                    />
                    {AQErrors?.VStatus && (
                      <span
                        className="error-message"
                        style={{ marginLeft: "10px" }}
                      >
                        {AQErrors?.VStatus}{" "}
                      </span>
                    )}
                    <input
                      type="text"
                      placeholder="Enter text"
                      className="Search p-1 w-100"
                      value={OComments?.Verification}
                      onChange={(e) =>
                        HandelOComments("Verification", e.target.value)
                      }
                    />
                  </Col>
                  <Col>
                    {" "}
                    <div className="DropdownHeader">
                      Question<span>*</span>
                    </div>
                    <TinyMCEDitor
                      onChange={(e) => StoreEditorValues("Question", e)}
                      PostValue={EditorValues?.Question}
                    />
                    {AQErrors?.Question && (
                      <span className="error-message">
                        {AQErrors?.Question}
                      </span>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </div>
          <div className="AddOptions">
            <div
              className="dflex alignitems JSBetween AUTitles"
              onClick={() => OpenAccordain("Q")}
            >
              <div className="dflex alignitems">
                {" "}
                <img src={Q} alt="Question" />{" "}
                <div>
                  Answer<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown />
            </div>
            {Accordion !== "Q" && (
              <div className="container-fluid mt-2QuestionOptions">
                <Row>
                  {MDQ === "D" && (
                    <Col>
                      <AnswerType
                        className="NCLDropdown w-100 mb-2"
                        SubjectId="0"
                        LovId="70"
                        PID="0"
                        LID="0"
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Answer Type<span>*</span>{" "}
                          </div>
                        }
                        StoreValue={SetAType}
                        Preselect="true"
                        SOption={AType}
                        onChange={(e) => {
                          SetAType(e);
                          SetUnits("");
                        }}
                        Type="Radio"
                        Name="AType"
                        HideOption="O"
                      />
                      <AnswerValuetype
                        className="NCLDropdown w-100 mb-2"
                        SubjectId="0"
                        LovId="71"
                        PID="0"
                        LID="0"
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Answer Value Type <span>*</span>{" "}
                          </div>
                        }
                        StoreValue={SetAVType}
                        Preselect="true"
                        SOption={AVType || GetQuestion?.answerValType}
                        onChange={(e) => {
                          SetAVType(e);
                          SetEditorValues({ ...EditorValues, Answer: "" });
                          setMultipleInputs([""]);
                        }}
                        Type="Radio"
                        Name="AVType"
                        HideOption={AType?.Name || ""}
                      />
                      {AType?.Name === "U" && (
                        <>
                          <UnitsDD
                            className="NCLDropdown w-100"
                            SubjectId="0"
                            LovId="72"
                            PID={AType?.Value}
                            LID="0"
                            labelname={
                              <div className="DropdownHeader mt-2">
                                {" "}
                                Unit of Measure <span>*</span>
                              </div>
                            }
                            StoreValue={SetUnits}
                            Displayname="Select Units"
                            SOption={Units}
                            onChange={(e) => {
                              SetUnits(e);
                            }}
                            HideOption="O"
                          />
                          {AQErrors?.Units && (
                            <span className="error-message">
                              {AQErrors?.Units}
                            </span>
                          )}
                        </>
                      )}
                    </Col>
                  )}

                  <Col>
                    <div className="dflex JSBetween mt-1">
                      <div className="DropdownHeader">
                        {AVType?.Name === "S" ? "Answer" : "Answers"}{" "}
                        <span>*</span>
                      </div>
                      {AVType?.Name === "M" && MDQ === "D" && (
                        <div className="LinkStyles" onClick={handleAddInput}>
                          Add another answer
                        </div>
                      )}
                    </div>
                    {MDQ === "M" ? (
                      <div className="dflex InputFIlters mt-3 gap-4">
                        <label style={{ backgroundColor: "white" }}>
                          {" "}
                          Select Answer{" "}
                        </label>
                        {["A", "B", "C", "D"].map((option, i) => (
                          <div
                            key={i}
                            className="dflex alignitems gap-2"
                            onChange={() => StoreEditorValues("Answer", option)}
                            style={{ fontSize: "15px" }}
                          >
                            <input
                              type="radio"
                              value={option}
                              name="Answer"
                              checked={option == EditorValues?.Answer}
                            />
                            {option}
                          </div>
                        ))}{" "}
                      </div>
                    ) : (
                      <>
                        {(AType?.Name == "T" || AType?.Name == "F") &&
                        AVType?.Name === "S" ? (
                          <TinyMCEDitor
                            onChange={(e) => StoreEditorValues("Answer", e)}
                            PostValue={EditorValues?.Answer}
                            disable={AVType == 8409}
                          />
                        ) : (
                          <>
                            {AVType?.Name === "M" || AVType?.Name === "S" ? (
                              <>
                                {MultipleInputs.map((input, index) => (
                                  <div key={index} className="RangeInputs">
                                    <input
                                      type={InputType(AType?.Name)}
                                      className="NCLDropdown w-100"
                                      value={
                                        inputValue(index) ||
                                        MultipleInputs[index]
                                      }
                                      onChange={(e) => handleChange(index, e)}
                                      placeholder="Enter Answer"
                                    />

                                    {index !== 0 && (
                                      <IoIosRemoveCircleOutline
                                        onClick={() => handleRemoveInput(index)}
                                        className="Remove-Input"
                                      />
                                    )}
                                  </div>
                                ))}
                              </>
                            ) : (
                              <>
                                <div>
                                  Range From :
                                  <input
                                    type="number"
                                    className="NCLDropdown w-100 mb-3"
                                    value={RangeValues?.From}
                                    onChange={(e) =>
                                      SetRangevalues({
                                        ...RangeValues,
                                        From: e.target.value,
                                      })
                                    }
                                    placeholder="Enter From Value"
                                  />
                                  {AQErrors?.From && (
                                    <span className="error-message">
                                      {AQErrors?.From}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  Range To :
                                  <input
                                    type="number"
                                    className="NCLDropdown w-100"
                                    value={RangeValues?.To}
                                    onChange={(e) =>
                                      SetRangevalues({
                                        ...RangeValues,
                                        To: e.target.value,
                                      })
                                    }
                                    placeholder="Enter To Value"
                                  />
                                  {AQErrors?.To && (
                                    <span className="error-message">
                                      {AQErrors?.To}
                                    </span>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {AVType?.Name !== "M"
                      ? AQErrors?.Answer && (
                          <span className="error-message">
                            {AQErrors?.Answer}
                          </span>
                        )
                      : AQErrors?.MultipleInputs && (
                          <span className="error-message">
                            {AQErrors?.MultipleInputs}
                          </span>
                        )}
                  </Col>
                  {MDQ === "M" && <Col></Col>}
                </Row>

                {MDQ !== "D" && (
                  <>
                    <Row>
                      {["A", "B"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">
                            {" "}
                            Option {item} <span>*</span>{" "}
                          </div>
                          <TinyMCEDitor
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />
                          {AQErrors?.[`Option${item}`] && (
                            <span className="error-message">
                              {" "}
                              {AQErrors?.[`Option${item}`]}{" "}
                            </span>
                          )}
                        </Col>
                      ))}
                    </Row>

                    <Row>
                      {["C", "D"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">Option {item} </div>
                          <TinyMCEDitor
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />{" "}
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
                <Row>
                  {["Explanation", "Misconception"].map((item, index) => (
                    <Col key={index}>
                      {" "}
                      <div className="DropdownHeader">{item} </div>
                      <TinyMCEDitor
                        onChange={(e) => StoreEditorValues(item, e)}
                        PostValue={EditorValues?.[item]}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </div>
          <div className="AddOptions">
            <div
              className="dflex alignitems JSBetween AUTitles"
              onClick={() => OpenAccordain("LOC")}
            >
              <div className="dflex alignitems">
                {" "}
                <img src={LO} alt="Learning Outcomes" />{" "}
                <div>Learning Outcomes </div>
              </div>{" "}
              <GoTriangleDown />
            </div>
            {Accordion !== "LOC" && (
              <div className="container-fluid">
                <Row>
                  <Col>
                    <DDContent
                      Displayname="Select Content"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetContent}
                      SOption={Content}
                      LID={SelectLanguage}
                      onChange={(e) => SetContent(e)}
                    />{" "}
                    {AQErrors?.Content && (
                      <span className="error-message">{AQErrors?.Content}</span>
                    )}
                  </Col>
                  <Col>
                    <DDTopic
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SeTopic}
                      SOption={Topic}
                      LID={SelectLanguage}
                      Displayname="Select Topic"
                      labelName={
                        <div className="DropdownHeader">
                          Topic<span>*</span>
                        </div>
                      }
                      onChange={(e) => SeTopic(e)}
                      LovCategoryId={4}
                    />
                    {AQErrors?.Topic && (
                      <span className="error-message">{AQErrors?.Topic}</span>
                    )}
                  </Col>
                  <Col>
                    <DDSubTopic
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={Topic}
                      LID={SelectLanguage}
                      StoreValue={SetSubTopic}
                      SOption={SubTopic}
                      Displayname="Select Sub Topic"
                      onChange={(e) => SetSubTopic(e)}
                      LovCategoryId={5}
                      labelName={
                        <div className="DropdownHeader">
                          Sub Topic<span>*</span>
                        </div>
                      }
                    />{" "}
                    {AQErrors?.SubTopic && (
                      <span className="error-message">
                        {AQErrors?.SubTopic}
                      </span>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <DDLearningOC
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={SubTopic}
                      LID={SelectLanguage}
                      StoreValue={SetLOC}
                      Displayname="Select Learning Outcomes"
                      labelName={
                        <div className="DropdownHeader">
                          Learning Outcomes<span>*</span>
                        </div>
                      }
                      SOption={LOC}
                      onChange={(e) => SetLOC(e)}
                      LovCategoryId={40}
                    />
                    {AQErrors?.LOC && (
                      <span className="error-message">{AQErrors?.LOC}</span>
                    )}
                  </Col>
                  <Col>
                    <DDSubLearningOC
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={LOC}
                      LID={SelectLanguage}
                      StoreValue={SetSubLOC}
                      Displayname="Select Sub Learning Outcomes"
                      SOption={SubLOC}
                      onChange={(e) => SetSubLOC(e)}
                      LovCategoryId={41}
                    />
                    {AQErrors?.SubLOC && (
                      <span className="error-message">{AQErrors?.SubLOC}</span>
                    )}
                  </Col>
                  <Col>
                    <NCERTLO
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetNCERTLOC}
                      Displayname="Select NCERT Learning Outcome"
                      SOption={NCERTLOC}
                      LID={SelectLanguage}
                      onChange={(e) => SetNCERTLOC(e)}
                      LovCategoryId={8}
                    />
                    {AQErrors?.NCERTLOC && (
                      <span className="error-message">
                        {AQErrors?.NCERTLOC}
                      </span>
                    )}
                    <div
                      className="dflex alignitems CPointer"
                      style={{ fontSize: "10px", gap: "3px" }}
                      onClick={GetNCERTLOCDetails}
                    >
                      {" "}
                      <IoInformationCircleOutline /> Click to view NCERT LOs
                      description
                    </div>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DropdownValues
                      className="NCLDropdown w-100"
                      options={ChapterOpt}
                      selectoption={CNumber}
                      Displayname="Select Chapter"
                      onChange={(e) => SetCNumber(e.target.value)}
                      labelname={
                        <div className="DropdownHeader">
                          CBSE / SCERT Chapter No<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.CNumber && (
                      <span className="error-message">{AQErrors?.CNumber}</span>
                    )}
                  </Col>
                  <Col>
                    <DropdownValues
                      Displayname="Select Grade"
                      className="NCLDropdown w-100"
                      options={GradeOpt}
                      onChange={(e) => SetGetGrade(e.target.value)}
                      selectoption={GetGrade}
                      labelname={
                        <div className="DropdownHeader">
                          Grade<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.GetGrade && (
                      <span className="error-message">
                        {AQErrors?.GetGrade}
                      </span>
                    )}
                  </Col>
                  <Col></Col>
                </Row>
              </div>
            )}
          </div>

<div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div> Competencies<span className="text-danger">*</span></div>
              </div>{" "}
            </div>
            <div className="container-fluid">
              <Row>
                <Col>
                  <StageDD className="NCLDropdown w-100" StoreMSource={SetSStage} SOption={SStage}
                    onChange={(e) => {SetSStage(e);SetSCGoal("");SetCompetencie("");SetFCompetencie("");}} Displayname="Select Stage" LID={items?.subjectId == 1 ? 99 : 102} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Stage<span>*</span> </div>} />
                  {AQErrors?.SStage && (<span className="error-message"> {AQErrors?.SStage} </span>)}
                </Col>
                <Col>
                  <CircularGoalDD className="NCLDropdown w-100" StoreMSource={SetSCGoal} SOption={SCGoal}
                    onChange={(e) => {SetSCGoal(e);SetCompetencie("");}} Displayname="Select Curricular Goal" LID={items?.subjectId == 1 ? 100 : 103} PId={SStage} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Curricular Goal<span>*</span> </div>} GetDetails={SetFSCGoal} />
                  {AQErrors?.SCGoal && (<span className="error-message"> {AQErrors?.SCGoal} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FSCGoal)}
                  > <IoInformationCircleOutline /> Click to view Curricular Goal description </div>
                </Col>
                <Col>
                  <CompetenciesDD className="NCLDropdown w-100" StoreMSource={SetCompetencie} SOption={Competencie}
                    onChange={(e) => SetCompetencie(e)} Displayname="Select Competencies" LID={items?.subjectId == 1 ? 101 : 104} PId={SCGoal} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Competencies<span>*</span> </div>} GetDetails={SetFCompetencie} />
                  {AQErrors?.Competencie && (<span className="error-message"> {AQErrors?.Competencie} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FCompetencie)}
                  > <IoInformationCircleOutline /> Click to view Competencies description </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="AddOptions">
            <div
              className="dflex alignitems JSBetween AUTitles"
              onClick={() => OpenAccordain("AP")}
            >
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Assessment Parameters" />{" "}
                <div>Assessment Parameters </div>
              </div>{" "}
              <GoTriangleDown />
            </div>
            {Accordion !== "AP" && (
              <div className="container-fluid">
                <Row>
                  <Col>
                    <QuestionLevel
                      Displayname="Select Question Level"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetQLevel}
                      SOption={QLevel}
                      LID={SelectLanguage}
                      onChange={(e) => SetQLevel(e)}
                      labelname={
                        <div className="DropdownHeader">
                          Question Level <span>*</span>
                        </div>
                      }
                      LovCategoryId={1}
                    />
                    {AQErrors?.QLevel && (
                      <span className="error-message">{AQErrors?.QLevel}</span>
                    )}
                  </Col>
                  <Col>
                    <BloomTaxonomy
                      Displayname="Select Bloom's Taxonomy"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={QLevel}
                      LID={SelectLanguage}
                      StoreValue={SetBTaxonomy}
                      SOption={BTaxonomy}
                      onChange={(e) => SetBTaxonomy(e)}
                      labelname={
                        <div className="DropdownHeader">
                          Bloom's Taxonomy <span>*</span>
                        </div>
                      }
                      LovCategoryId={42}
                    />
                    {AQErrors?.BTaxonomy && (
                      <span className="error-message">
                        {AQErrors?.BTaxonomy}
                      </span>
                    )}
                  </Col>
                  <Col>
                    <DDContext
                      Displayname="Select Context "
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetContext}
                      SOption={Context}
                      LID={SelectLanguage}
                      onChange={(e) => SetContext(e)}
                    />{" "}
                    {AQErrors?.Context && (
                      <span className="error-message">{AQErrors?.Context}</span>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </div>
          <div className="AddOptions">
            <div
              className="dflex alignitems JSBetween AUTitles"
              onClick={() => OpenAccordain("FQ")}
            >
              <div className="dflex alignitems">
                {" "}
                <img src={Forms} alt="Assessment Parameters" />{" "}
                <div>
                  Forms In Question<span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
              <GoTriangleDown />
            </div>
            {Accordion !== "FQ" && (
              <>
                <FormQuestions
                  PostValues={FormQ}
                  LID={SelectLanguage}
                  onChange={(e) => FormSOptions(e)}
                />
                {FormQ.includes(4002) && (
                  <>
                    <input
                      type="text"
                      className="Search mt-2 p-1 w-100"
                      onChange={(e) => HandelOComments("Form", e.target.value)}
                      placeholder="Enter Comments"
                    />
                    {AQErrors?.Form && (
                      <span className="error-message">{AQErrors?.Form}</span>
                    )}
                  </>
                )}
                {AQErrors?.QForm && (
                  <span className="error-message">{AQErrors?.QForm}</span>
                )}
              </>
            )}
          </div>
        </div>
        
<QBCList Heading="Question" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetQCValues} Existinvalues={GetQuestion?.status} ExistingId={GetQuestion?.checklistQuestionId} LanguageId={SelectLanguage} />
     
        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={BackPreviousPage}>
            Cancel
          </button>
          <button
            className="Buttons bg-success"
            onClick={() => {
              Validation(); SetHitCLV(true);
            }}
          >
            Save{" "}
          </button>
        </div>
      </div>

      {NCERTDetails && (
        <div className="Model-Open">
          <div className="Card w-55 m-4">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => SetNCERTDetails()}
            />
            <DataTable
              data={NCERTDetails}
              columns={NCERTColumns}
              className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]}
              ShowPagination="true"
              ShowPagecount="true"
            />
          </div>
        </div>
      )}
       {OpenDeatils && (
              <div className="Model-Open">
                <div className="Card w-100 Model-Content">
                  <IoMdCloseCircleOutline
                    className="NCERTClose CPointer"
                    onClick={() => SetOpenDeatils()}
                  />
                  <DataTable data={OpenDeatils} columns={Columns} className="NCLDataTable"
                    Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
                </div>
              </div>
            )}
      {Load && <Loading />}
    </>
  );
};
export default CloneAddQuestion;
